import { Component, OnInit } from '@angular/core';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {from} from 'rxjs';
import {ReportService} from '~/app/core/common/services/report.service';
import {ReportColumnTitles} from '~/app/core/common/models/ReportColumnTitles';
import {process, State} from '@progress/kendo-data-query';
import {GridDataResult} from '@progress/kendo-angular-grid';
import {DatePipe} from '@angular/common';


@Component({
  selector: 'app-new-item',
  templateUrl: './new-item.component.html',
  styleUrls: ['./new-item.component.scss']
})
export class NewItemComponent implements OnInit {
  value: Date;
  public columns = ReportColumnTitles.NEW_ITEM_COLUMNS;
  public state: State = {};
  public gridData: GridDataResult = undefined;
  loading: any = false;
  constructor(public _storeListService: StoreListService, public _reportService: ReportService, public datepipe: DatePipe) {
  }

  ngOnInit() {
  }

  public disableDates = (date: Date): boolean => {
    return date > new Date();
  }

  searchByDate() {
    this.loading = true;
    this._reportService.getNewItemsReport(this._storeListService.pickedCustomerId, this.datepipe.transform(this.value, 'MM-dd-yyyy'))
        .toPromise().then((result) => {
      console.log(result);
      result.forEach((item) => {
        item.criticalstring = item.critical ? 'Yes' : 'No';
      });
      this.gridData = process(result, this.state);
      this.loading = false;
    }).catch((error ) => {
      console.log(error);
    }).finally(() => {
      this.loading = false;
    });
  }

}
